import { useQuery } from 'react-query';
import { trackPromise } from 'react-promise-tracker';
import { getPluginInstances, getPluginInstance } from '../index';
export const useGetPluginInstances = (additionlInfo) => useQuery(['GetAllPluginInstances', additionlInfo], () => trackPromise(getPluginInstances(additionlInfo)), {
    cacheTime: 0
});
export const useGetPluginInstance = (additionlInfo) => useQuery(['GetPluginInstanceByGuid', additionlInfo], () => trackPromise(getPluginInstance(additionlInfo)), {
    cacheTime: 0
});
